<template>
  <div>
    <h3 ref="intro">
      Line of Symmetry
    </h3>
    <p>
      For a symmetric shape, a line of symmetry is an imaginary line such that if you fold the shape along this line, one half is exactly the same as the other half.
      <br><br>
      For example, consider the butterfly cartoon shown below.
      If you were to fold the butterfly shape along the dotted vertical line, you will find
      that the two halves are identical to each other.
      <br><br>
      Thus, the dotted line represents the line of symmetry for the butterfly shape.
    </p>
    <v-layout justify-center>
      <v-img src="/assets/symmetryLine-3.png"
             max-height="350px"
             max-width="350px"
             width="400px"
      />
    </v-layout>
    <v-layout justify-center>
      <h5> Figure: Line of symmetry for a butterfly shape. </h5>
    </v-layout>
    <br><br>
    <p>
      Shapes can have more than one lines of symmetry. For example, the floral shape below has two lines of symmetry.
    </p>
    <v-layout justify-center>
      <v-img src="/assets/symmetryLine-4.png"
             max-height="350px"
             max-width="350px"
             width="400px"
      />
    </v-layout>
    <v-layout justify-center>
      <h5> Figure: Floral shape with two lines of symmetry. </h5>
    </v-layout>
    <h3 ref="pg">
      MagicGraph | Find the Line of Symmetry
    </h3>
    <p>
      In this MagicGraph, we show how to find the line of symmetry of a symmetric object.
      Shown in the MagicGraph is a triangle that is made of a two-colored piece of cloth.
      The cloth is red-colored on the front and blue-colored on the back.
      <br><br>
      The triangle shape can be folded over along the blue line. Move the blue line around to see
      the two sides of the fold.
      <br> <br>
      As you move the blue line, the MagicGraph automatically folds the triangle shape over along this line. <br><br>
      To find the line of symmetry, move the blue line until the one side of the fold sits exactly on top of the other side.
      <br> <br>
    </p>
    <v-responsive>
      <v-layout justify-center>
        <div id="jxgbox1" class="edliy-box-about" />
      </v-layout>
    </v-responsive>
  </div>
</template>
<script>
import Boxes from './Boxes.js'
export default {
  name: 'SymmetryLine',
  created: function () {
    this.$store.commit('navigation/resetState');
    let title = 'Line of Symmetry';
    this.$store.commit('navigation/changeTitle', title);
    this.$store.commit('navigation/changeMenu', title);
    let newTopics = [
      {title: 'Parallel Lines', img:'/assets/number-1.svg', action: () => this.goto('intro')},
      {title: 'Transversal', img:'/assets/number-2.svg', action: () => this.goto('trans')},
      {title: 'Pair of Angles', img:'/assets/number-3.svg', action: () => this.goto('angles')},
      {title: 'MagicGraph',img:'/assets/touch.svg', action: () => this.goto('pg')},
    ];
    this.$store.commit('navigation/replaceTopics', newTopics);
    let newshowhome = false;
    this.$store.commit('navigation/toggleshowhome', newshowhome);
    let newMath =true;
    this.$store.commit('navigation/replaceMath', newMath);
    let newLeftArrow =true;
    this.$store.commit('navigation/replaceLeftArrow', newLeftArrow);
    let newModule=true;
    this.$store.commit('navigation/replaceModule', newModule);
  },
  mounted () {
    MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    Boxes.box1();
  },
  metaInfo() {
  return{ title: 'Line of Symmetry',
          titleTemplate: '%s - Learn interactively',
          meta: [ {name: 'viewport', content: 'width=device-width, initial-scale=1'},
                  {name: 'description', content: 'Learn interactively how to draw a free body diagram'}
                ]
        }
   },
}
</script>
<style lang="scss">
@import 'src/styles/edliy-box.scss';
@import 'src/styles/subtopic-menu.scss';
@import 'src/styles/edliy-box-about.scss';
@import 'src/styles/screen-sizes.scss';
</style>
